import { createStore } from 'vuex'

const store = createStore({
  modules: {},
  strict: true,
  plugins: []
})

export default store 